import React from 'react';
import GoogleMap from '../Modules/GoogleMap';
import AutoComplete from '../Modules/AutoComplete.js';
import {InitMap, GetAllReadyToAccPoints} from './Report.js';
import './style.css';

export default function Report() {
    GetAllReadyToAccPoints();
    const [google, setGoogle] = React.useState(null);
    const [map, setMap] = React.useState(null);
    React.useEffect(() => {
        document.title = 'Barpazir';
    }, [])
    return (
        <div className='report'>
            <div className="main">
                <div className="mapWrapper">
                    <GoogleMap callback={SetGoogleMap} apiKey="AIzaSyDYUWypkG-EMd_7A_Uh7YeyxYq0LtWop2E" />
                    <AutoComplete minLength="3" source={Search4Cities} changed={Changed} select={Select} />
                </div>
            </div>
        </div>
    )
    function SetGoogleMap(g) {
        setGoogle((o) => g);
        setMap(() => InitMap(g) );
    }
    function Search4Cities(keyword, callback) {
        fetch(`https://nominatim-ac.eelpieconsulting.co.uk/search/?profile=countryStateCity&q=${keyword}`)
            .then(response => response.json())
            .then(data => {
                let filteredAndProccessedData = [];
                data.map((item, index) => {
                    if (',ar,au,br,ca,mx,us,'.indexOf(`,${item.country},`) === -1 && (item.displayType === 'country' || item.displayType === 'city' || item.classification === 'boundary'))
                        filteredAndProccessedData.push({ id: filteredAndProccessedData.length, value: item.address });
                });
                callback(filteredAndProccessedData)
            })
            .catch(() => {
                console.log('بروز اشکال در بازیابی اطلاعات!');
            });
    }
    function Changed(value) {
        //console.log('Changed');
    }
    function Select(value) {
        fetch(`https://nominatim.openstreetmap.org/search?format=json&polygon_geojson=1&q=${value}`)
            .then(response => response.json())
            .then(data => {
                if (data.length > 0) {
                    let bBox = data[0].boundingbox;
                    let foundBounds = new google.maps.LatLngBounds();
                    let pTopLeft = new google.maps.LatLng(bBox[1], bBox[2])
                    let pBottomRight = new google.maps.LatLng(bBox[0], bBox[3])
                    foundBounds.extend(pTopLeft);
                    foundBounds.extend(pBottomRight);
                    map.fitBounds(foundBounds);
                }
             })
            .catch(() => {
                console.log('بروز اشکال در بازیابی اطلاعات!');
            });
    }
}